import {
  ActionReducerMap,
  createSelector,
  createFeatureSelector,
  MetaReducer,
} from '@ngrx/store';
import { IAppState } from '../state/IAppState';
import { appStateReducer } from './appState.reducer';
import { logger } from './logger.meta-reducer';
import * as fromRouter from '@ngrx/router-store';
import { RouterStateUrl } from '../../../common/utilities/RouterStateUrl';

/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */
import { storeFreeze } from 'ngrx-store-freeze';

export interface State {
  app: IAppState,
  routerReducer: fromRouter.RouterReducerState<RouterStateUrl>
};

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<State> = {
  app: appStateReducer,
  routerReducer: fromRouter.routerReducer
};

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 
export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [logger, storeFreeze]
  : [];*/
export const metaReducers: MetaReducer<State>[] = [logger];



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/index.ts